import { render, staticRenderFns } from "./model_list.vue?vue&type=template&id=b4fb7596&scoped=true"
import script from "./model_list.vue?vue&type=script&lang=ts"
export * from "./model_list.vue?vue&type=script&lang=ts"
import style0 from "./model_list.vue?vue&type=style&index=0&id=b4fb7596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fb7596",
  null
  
)

export default component.exports